import { indexItems } from "@/mocks/home";

const statusMap: Record<string, string> = {
  已回应: "bg-foreground-950 text-background-50",
  待求证: "bg-accent-500 text-background-50",
  无实据: "bg-secondary-200 text-foreground-700",
  持续讨论: "bg-primary-100 text-primary-800",
};

function IndexCollection() {
  return (
    <section id="index" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-20">
        <div className="grid gap-6 lg:grid-cols-[0.9fr_1.6fr]">
          {/* Sticky intro rail */}
          <div className="lg:sticky lg:top-28 lg:self-start">
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 font-label text-xs uppercase tracking-[0.2em] text-background-50">
              <i className="ri-list-check-3"></i>
              索引 · Index
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black leading-snug text-foreground-950 md:text-4xl">
              真名照片与背景
              <span className="text-primary-600">线索索引</span>
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
              这是全页信息最密的模块。把散落各处的“他是谁”说法按条目建档，每条附上来源类型与核实状态，方便按状态筛选、按逻辑对照。
            </p>

            <div className="mt-6 space-y-2.5">
              {[
                { k: "已回应", d: "账号做过澄清或给出方向" },
                { k: "待求证", d: "流传广，但缺少可靠出处" },
                { k: "无实据", d: "说法存在，证据支撑不足" },
                { k: "持续讨论", d: "仍在发酵，尚无收敛迹象" },
              ].map((s) => (
                <div key={s.k} className="flex items-start gap-2.5">
                  <span
                    className={
                      "mt-0.5 inline-flex w-16 shrink-0 justify-center rounded-full px-2 py-1 text-center text-[11px] font-semibold " +
                      statusMap[s.k]
                    }
                  >
                    {s.k}
                  </span>
                  <span className="text-xs leading-relaxed text-foreground-600">{s.d}</span>
                </div>
              ))}
            </div>
          </div>

          {/* List */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {indexItems.map((item) => (
              <article
                key={item.id}
                className="flex flex-col rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70 transition-colors hover:ring-primary-200"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className={"inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold " + statusMap[item.status]}>
                    {item.status}
                  </span>
                  <span className="whitespace-nowrap font-label text-[11px] uppercase tracking-wider text-foreground-400">
                    #{String(indexItems.indexOf(item) + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-4 flex items-center gap-1.5 border-t border-background-200/60 pt-3 text-xs text-foreground-500">
                  <i className="ri-focus-3-line text-accent-600"></i>
                  <span>来源：{item.source}</span>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* footnote */}
        <p className="mt-8 flex items-start gap-2 rounded-lg bg-secondary-50 px-4 py-3 text-xs leading-relaxed text-foreground-600 ring-1 ring-background-200/60">
          <i className="ri-information-line mt-0.5 text-primary-500"></i>
          <span>
            说明：以上线索均来自公开渠道的转述与讨论，仅供信息对照，不代表本站认同或证明任何说法。关于“四一爆料真名、照片”等内容目前均无实锤，请勿据此对任何个人或账号下结论。
          </span>
        </p>
      </div>
    </section>
  );
}

export default IndexCollection;